export class ProductLine {
    productLineID: number;
    productLineDesc: string;
    isActive: boolean;
    imageUrl: string;
    productFamilyID: number;
    vintageStart: string;
    vintageEnd: string;
  code: string;
  image: ByteString;

}



// WEBPACK FOOTER //
// ./src/opc/opc-app/productline/productline.model.ts